export default "__VITE_ASSET__BGIemlOj__"